// SkeletonCard.jsx — cartes squelettes du premier chargement mobile.
// Présentation pure : aucune donnée, aucun appel réseau. Couleurs : tokens --ndoe-* uniquement.
import React from 'react';
import './skeletonCard.css';

export const SkeletonCard = ({ variant = 'kpi', className = '' }) => {
  if (variant === 'panel') {
    return (
      <div className={`ndoe-skeleton-card is-panel ${className}`.trim()} aria-hidden="true">
        <div className="ndoe-skeleton-block is-kicker" />
        <div className="ndoe-skeleton-block is-title" />
        <div className="ndoe-skeleton-block is-line" />
        <div className="ndoe-skeleton-block is-line" />
        <div className="ndoe-skeleton-block is-line is-short" />
      </div>
    );
  }
  return (
    <div className={`ndoe-skeleton-card is-kpi ${className}`.trim()} aria-hidden="true">
      <div className="ndoe-skeleton-head">
        <div className="ndoe-skeleton-block is-icon" />
        <div className="ndoe-skeleton-block is-kicker" />
      </div>
      <div className="ndoe-skeleton-block is-value" />
      <div className="ndoe-skeleton-block is-line is-short" />
    </div>
  );
};

export default SkeletonCard;
